













import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
})

export default class SFTextarea extends Vue {
    @Prop({}) data: any;

}
